var exports = {
  "wrapper": "xaee3c4fa--73181e--wrapper",
  "publish": "xaee3c4fa--73181e--publish",
  "draft": "xaee3c4fa--73181e--draft",
  "decline": "xaee3c4fa--73181e--decline",
};

module.exports = exports;
